import React, { useState, useEffect, Fragment } from "react";
import { Modal, ModalHeader, ModalBody, Container, Row, Col } from "reactstrap";

const ImagePreview = ({ previewUrl, onVisibleChanged }) => {
    const [modal, setModal] = useState(false);
    
    const toggle = () => {
        setModal(!modal);
        if (modal && onVisibleChanged) {
            onVisibleChanged(null);
        }
    };

    useEffect(() => {
        if (previewUrl) {
            setModal(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previewUrl]);

    return (
        <Fragment>
            <Modal isOpen={modal} toggle={toggle} fullscreen>
                <ModalHeader toggle={toggle}>Image Preview</ModalHeader>
                <ModalBody>
                    <Container>
                        <Row>
                            <Col md="12">
                                <img className="w-100" src={previewUrl} />
                            </Col>
                        </Row>
                    </Container>
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default ImagePreview;
